import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import bookIcon from '../../images/book-open-flat.svg';
import reward from '../../images/reward.svg';
import coach from '../../images/coach-icon.png';

function HomeWhy(props){

  return (
    <section id="HomeWhy">
      <h1 className="home-heading">Why Use Close Reading?</h1>

      <div className="home-why-card">
        <img alt="book" className="home-why-img-left" src={bookIcon}></img>
        <div className="home-why-text">
          <h3>Reading Poety is <em>Tough</em></h3>

          <p>A lot of readers avoid poetry simply because they don't seem to get much out of it. Some find it painful, that's because poetry is difficult!</p>

          <h4 className="home-why-quote">"Your pain is the breaking of the shell that encloses your understanding."  —Khalil Gibran</h4>
        </div>
      </div>

      <div className="home-why-card">
        <div className="home-why-text">
          <h3>The Rewards Are Unlike <em>Any Other</em></h3>

          <p>So why learn how to read poetry? Poetry is transformative, tackling some of the toughest problems in life. Want to develop your emotional intelligence? Become a better leader? Understand yourself? Improve your relationship? Figure out what to do next in life? Read poetry!</p>

          <h4 className="home-why-quote">"We make out of the quarrel with others, rhetoric, but of the quarrel with ourselves, poetry." —William Butler Yeats</h4>
        </div>
        <img alt="reward" className="home-why-img-right" src={reward}></img>
      </div>

      <div className="home-why-card">
        <img alt="coach" className="home-why-img-left" src={coach}></img>
        <div className="home-why-text">
          <h3>Step-By-Step Exercises to Guide You</h3>

          <p>Don't read alone! Close Reading offers step-by-step exercises that develop reading comprehension. You'll be trained in the art of <em>close reading</em>, a technique developed to aid interpretation of poems. Using Close Reading's innovative and interactive interface, you'll feel as if a poet is guiding you through the works.</p>

          <h4 className="home-why-quote">“I'm not a teacher: only a fellow traveler of whom you asked the way. I pointed ahead - ahead of myself as well as you.” —George Bernard Shaw</h4>
        </div>
      </div>
    </section>
  )
}

export default HomeWhy;



// WEBPACK FOOTER //
// ./src/components/Home/HomeWhy.js